import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { CustomTextInput } from '../components/CustomTextInput';
import ButtonComponent from '../components/ButtonComponent';
import { getSecureItemFromSpecificStorage } from '../lib/BrowserStorageAccessMiddleware';
import {
  LOCAL_STORAGE,
  LS_CUSTOMER,
  LS_DOMAIN_AND_LOCKER_BANK,
  LS_PAGE_FLOW,
  LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS,
} from '../assets/constants/BrowserStorageKeys';
import { DoorResendOTP, openLocker, PickUpDoorVerification, releaseLockerOfPickUpUser } from '../api/api';
import { BUTTON_PRIMARY, ERROR, SUCCESS, TOAST_ERROR, TOAST_SUCCESS, TOAST_WARN } from '../assets/constants/Constants';
import CustomDialog from '../components/CustomDialog';
import { allowOnlyFourDigits, allowOnlyNumbers, getPathForNextPage, handleStoreUserDataInLocalStorage } from '../lib/Utils';
import CircularProgressLoader from '../components/CircularProgressLoader';
import ShowToast from '../components/ToastComponent';
import { DOOR_VERIFICATION_PAGE, LOCKER_OPENED, SWIPE_TO_OPEN_LOCKER } from '../assets/constants/PageList';
import {useTranslation} from 'react-i18next';

function ParcelPickUpDoorVerification() {
	const {t} = useTranslation();
	const [doorInput, setDoorInput] = useState('');
	const [otpInput, setOtpInput] = useState('');
	const [disabled, setDisabled] = useState(false);
  	const [message, setMessage] = useState("");
	const [dialogMessage, setDialogMessage] = useState('');
	const [isDialogVisible, setIsDialogVisible] = useState(false);
	const [ref_id, setRef_Id] = useState('');
	const [showLoader, setShowLoader] = useState(false);
	const [loadingMessage, setLoadingMessage] = useState('');
	const history = useHistory();
	const ls_page_flow = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_PAGE_FLOW);
	const assignmentSettings = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_TENANT_ASSIGNMENT_LOCKER_BANK_SETTINGS);
	const useCase = assignmentSettings?.usecase;
    const skip_swipe_to_open = assignmentSettings?.usecase_settings?.skip_swipe_to_open?.value;
	const DomainAndLockerId = getSecureItemFromSpecificStorage(LOCAL_STORAGE, LS_DOMAIN_AND_LOCKER_BANK );
	const lockerId = DomainAndLockerId?.lockerBankId;
	const slug = assignmentSettings?.slug;
	const ReleaseLockerAfterPicup = assignmentSettings?.usecase_settings?.release_after_pickup_pwa?.value;
	const [resend, setResend] = useState(false);
	const handleDoorNumber = (e) => {
		const value = e.target.value;
  		const numericValue = allowOnlyNumbers(value);
    	setDoorInput(numericValue);
	};

	const handleOtp = (e) => {
		const numericValue = allowOnlyFourDigits(e.target.value);
		setOtpInput(numericValue);
	};

	const handleResendOtp = async () => {
		if(!doorInput){
			ShowToast(t('warningEnterDoorNumberToResendOTP'), TOAST_WARN);
			return;
		}
		try {
			let body = {
			bank_id:lockerId,
			door_no:doorInput
			}
			const responseResend = await DoorResendOTP(slug, body);
			if(responseResend.status === SUCCESS){
				ShowToast(responseResend.message,TOAST_SUCCESS);
				setDoorInput('');
				setResend(false);
			}else{
				ShowToast(responseResend.message,TOAST_ERROR);
			}
			
		} catch (error) {
			console.error("Error resending OTP:", error);
			ShowToast(
				(error?.response?.data?.message) ||
					error?.message ||
					t('errorSomethingWentWrong'),
				TOAST_ERROR
			);
		} finally {
			setShowLoader(false);
		}
	};

	const handleSubmit = async () => {
		if(otpInput.length < 4){
			ShowToast(t('warningValidDoorNumberAndOTP'), TOAST_WARN);
			return;
		}
		if (!doorInput || !otpInput) {
			ShowToast(t('warningValidDoorNumberAndOTP'), TOAST_WARN);
		return;
		}

		const data = {
		door_no: doorInput,
		otp: otpInput,
		bank_id: lockerId,
		};

		try {
			setShowLoader(true);
			setLoadingMessage(t('infoVerifyingDoorNumberAndOTP'));
			const response = await PickUpDoorVerification(slug, data);
			if (response?.status === "success") {
				handleStoreUserDataInLocalStorage(response?.data);
				let lockerUnitDetails = { 
					ref_id: response?.data?.ref_id,
					locker_door: {
						door_no: doorInput,
					}
				};
        
				if (!skip_swipe_to_open) {
					history.push({
						pathname: getPathForNextPage(DOOR_VERIFICATION_PAGE, SWIPE_TO_OPEN_LOCKER),
						state: { lockerUnitDetails },
					});
					return;
				}
				if (response?.data?.ref_id) {
					setLoadingMessage(t('opening_locker_please_wait'));
					const lockerOpenResponse = await openLocker(response?.data?.ref_id);
					if (lockerOpenResponse?.status === "success") {
						if(ReleaseLockerAfterPicup){
							setLoadingMessage(t('lockerReleasing'));
							const releaseLockerResponse = await releaseLockerOfPickUpUser(response?.data?.ref_id);
							if (releaseLockerResponse?.status === "success") {
								ShowToast(t('lockerOpendAndReleased'), TOAST_SUCCESS);
								history.push(getPathForNextPage(DOOR_VERIFICATION_PAGE, LOCKER_OPENED));
								
							}else{
								ShowToast(t('lockerOpendNotReleased'), TOAST_ERROR);
							}
						}else{
							ShowToast(t('page_title_locker_opened'), TOAST_SUCCESS);
							history.push(getPathForNextPage(DOOR_VERIFICATION_PAGE, LOCKER_OPENED));
						}
						
					} 
					else {
						ShowToast(lockerOpenResponse?.message || t('errorFailedToOpenLocker'),TOAST_ERROR);
					}
				}
				else {
					ShowToast(t('errorLockerReferenceIDNotFound'), TOAST_ERROR);
				}
			} 
			else {
				ShowToast(t('errorInvalidData'), TOAST_ERROR);
			}
		} 
		catch (error) {
			console.error("Error verifying door:", error);
			console.log();
			if(error.response.data.message == "Maximum OTP attempts reached. Please try again."){
					setDisabled(true);
    				setMessage(t('maximumOtpAttempts'));
					setOtpInput('');
					setDoorInput('');
			}
			else if(error.response.data.message == "OTP Expired"){
				setResend(true);
				setOtpInput('');
			}
			ShowToast(
				(error?.response?.data?.message) ||
					error?.message ||
					t('errorSomethingWentWrong'),
				TOAST_ERROR
			);
		} 
		finally {
			setShowLoader(false);
		}
	};

	return (
		<div className="parcel-pick-door-verification-page">
			<div className="main-container">
				<div className="main">
					<div className="verification-container">
						<div className="enter-door-number-container">
							{/* <p>{t('infoEnterDoorNumber')}</p> */}
							<CustomTextInput text = {t('infoEnterDoorNumber')} placeholder={t('infoEnterDoorNumber')} value={doorInput} onChange={handleDoorNumber} type="number"/>
						</div>
						<div className="enter-otp-container">
							{ !resend &&
							<>
								{/* <p>{t('enter_otp')}</p> */}
								<CustomTextInput text = {t('enter_otp')} placeholder={t('enter_otp')} value={otpInput} onChange={handleOtp} type="number"/>
							</>
							}
						</div>
						{message && <p className="error-text">{message}</p>}

						<div className="verification-button-container">
							<ButtonComponent title= {resend ? t('resend_otp_btn') : t('submit_btn')} handleClick={resend ? handleResendOtp : handleSubmit} disabled = {disabled} />
						</div>
					</div>

					{/* Custom Dialog */}
					<CustomDialog
						dialogId="error-dialog"
						dialogVisible={isDialogVisible}
						dialogTitle={t('errorVerification')}
						dialogContentText={dialogMessage}
						buttonTwoTitle={t('button_ok')}
						buttonProps={{
						buttonOne: { type: BUTTON_PRIMARY },
						buttonTwo: { type: BUTTON_PRIMARY },
						}}
						handleCancel={() => setIsDialogVisible(false)}
						handleAccept={() => setIsDialogVisible(false)}
					/>
				</div>
			{showLoader && (<CircularProgressLoader message={loadingMessage} />)}
			</div>
		</div>
	);
}

export default ParcelPickUpDoorVerification;  
